import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';


@Component({
  selector: 'app-rejected-reason',
  templateUrl: './rejected-reason.component.html',
  styleUrls: ['./rejected-reason.component.scss']
})
export class RejectedReasonComponent implements OnInit {

  @Input() responseDatas:any =[];
  keys:any = [];
  search:any;

  constructor(
    private modalService: NgbModal,
    private xls: XlsxService,
  ) { }

  ngOnInit() {
    this.keys = Object.keys(this.responseDatas[0])
    console.log(this.responseDatas);
    console.log(this.keys);
    
  }


  DownloadRejectedRecords() {
    this.xls.export(this.responseDatas, "Rejected Data")
  }


  closeModal() {
    this.modalService.dismissAll()
  }

}
